import CardLayout from '@/components/common/CardLayout';
import Modal from '@/components/common/modals/Modal';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { useMutation } from '@apollo/client';
import { ExternalFinancialEntity } from '@common/financialEntities';
import { ConfirmAddedFinancialEntityDocument } from '@common/graphql/generated';
import { useState } from 'react';

export interface FinancialEntityJointToIndividualModalProps {
    fe: ExternalFinancialEntity;
}

export const showFinancialEntityJointToIndividualModal = (
    props: FinancialEntityJointToIndividualModalProps
) => ModalManager.show(FinancialEntityJointToIndividualModal, props);

const FinancialEntityJointToIndividualModal =
    ModalManager.create<FinancialEntityJointToIndividualModalProps>(
        ({ fe }) => {
            useTrackModalShown('Financial Entity Joint to Individual');

            const modal = useModal();

            const [confirmAddedFinancialEntity] = useMutation(
                ConfirmAddedFinancialEntityDocument
            );
            const [isSubmitting, setIsSubmitting] = useState(false);

            const updateOwnership = () => {
                setIsSubmitting(true);
                confirmAddedFinancialEntity({
                    variables: {
                        financialEntityId: fe.id,
                        ownershipType: 'INDIVIDUAL',
                        isPrivate: fe.shareStatus !== 'SHARED',
                    },
                })
                    .then(() => {
                        modal.remove();
                    })
                    .finally(() => {
                        setIsSubmitting(false);
                    });
            };

            return (
                <Modal size="sm" isOpen={modal.visible} onClose={modal.remove}>
                    <CardLayout
                        title={`Are you sure you want to change the ownership?`}
                        primaryButtonText="Change ownership"
                        onPrimaryButton={() => {
                            updateOwnership();
                        }}
                        isPrimaryButtonLoading={isSubmitting}
                        onSecondaryButton={modal.hide}
                        onClickPrimaryEvent="Financial Entity Joint to Individual Modal - Confirm Change Ownership Button Clicked"
                        onClickSecondaryEvent="Financial Entity Joint to Individual Modal - Cancel Button Clicked"
                    ></CardLayout>
                </Modal>
            );
        }
    );

export default FinancialEntityJointToIndividualModal;
